import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=22875ec0&scoped=true&"
import script from "./change-language.vue?vue&type=script&lang=js&"
export * from "./change-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22875ec0",
  null
  
)

export default component.exports